'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignupFlowToPath;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SignupFlows = exports.SignupFlows = {
  CRM: 'CRM',
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  ACADEMY: 'ACADEMY',
  CLASSROOM_TRAINING: 'CLASSROOM_TRAINING',
  CONTENT: 'CONTENT',
  HUBSPOT_FOR_STARTUPS: 'HUBSPOT_FOR_STARTUPS',
  INTEGRATIONS: 'INTEGRATIONS',
  PURCHASE: 'PURCHASE',
  SERVICE: 'SERVICE',

  WORDPRESS: 'WORDPRESS',
  WORDPRESS_LOGIN: 'WORDPRESS_LOGIN',

  GROWTH_HUB: 'GROWTH_HUB',
  CHECKOUT: 'CHECKOUT',
  DEVELOPERS: 'DEVELOPERS',
  EMBEDDED: 'EMBEDDED'
};

var SignupFlowToPath = exports.SignupFlowToPath = (_SignupFlowToPath = {}, _defineProperty(_SignupFlowToPath, SignupFlows.CRM, 'crm'), _defineProperty(_SignupFlowToPath, SignupFlows.MARKETING, 'marketing'), _defineProperty(_SignupFlowToPath, SignupFlows.SALES, 'sales'), _defineProperty(_SignupFlowToPath, SignupFlows.ACADEMY, 'academy'), _defineProperty(_SignupFlowToPath, SignupFlows.CLASSROOM_TRAINING, 'classroom-training'), _defineProperty(_SignupFlowToPath, SignupFlows.CONTENT, 'content'), _defineProperty(_SignupFlowToPath, SignupFlows.HUBSPOT_FOR_STARTUPS, 'hubspot-for-startups'), _defineProperty(_SignupFlowToPath, SignupFlows.INTEGRATIONS, 'integrations'), _defineProperty(_SignupFlowToPath, SignupFlows.PURCHASE, 'purchase'), _defineProperty(_SignupFlowToPath, SignupFlows.SERVICE, 'service'), _defineProperty(_SignupFlowToPath, SignupFlows.WORDPRESS, 'wordpress'), _defineProperty(_SignupFlowToPath, SignupFlows.WORDPRESS_LOGIN, 'wordpress-login'), _defineProperty(_SignupFlowToPath, SignupFlows.GROWTH_HUB, 'growth-hub'), _defineProperty(_SignupFlowToPath, SignupFlows.CHECKOUT, 'checkout'), _defineProperty(_SignupFlowToPath, SignupFlows.DEVELOPERS, 'developers'), _defineProperty(_SignupFlowToPath, SignupFlows.EMBEDDED, 'embedded'), _SignupFlowToPath);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/constants/SignupFlows.js
// module id = 222
// module chunks = 0